import { Component, Input, OnInit } from '@angular/core';
import { CarModel } from "../../../../models/car/car.model";
import { faMapMarkerAlt, IconDefinition } from "@fortawesome/free-solid-svg-icons";
import { faCalendar } from "@fortawesome/free-regular-svg-icons";

interface IPickCarInformations {
    type: string;
    date: Date;
    place: string;
    address: string;
}

@Component({
    selector: 'pick-car-informations',
    template: `
        <strong>{{pickCarInformations.type}}</strong>
        <div class="date-info icon-info">
            <fa-icon [icon]="iconCalendar"></fa-icon>
            <span>{{pickCarInformations.date | date:'short':locale}}</span>
        </div>
        <div class="place-info icon-info">
            <fa-icon [icon]="iconLocation"></fa-icon>
            <div>
                <div>{{pickCarInformations.place}}</div>
                <div><small>{{pickCarInformations.address}}</small></div>
            </div>
        </div>

    `,
    styles: [`
        :host {
            display: flex;
            flex-direction: column;
        }

        strong {
            padding-bottom: .5rem;
        }


        .icon-info {
            padding-left: .325rem;
            display: flex;
            align-items: baseline;
        }

        .icon-info fa-icon {
            width: 20px;
        }

    `]
})
export class PickCarInformationsComponent implements OnInit {
    @Input()
    public booking: CarModel;
    @Input()
    public locale: string = 'fr';
    @Input()
    public type: 'pickup' | 'dropOff' = 'pickup';

    public pickCarInformations: IPickCarInformations;

    public iconCalendar: IconDefinition = faCalendar;
    public iconLocation: IconDefinition = faMapMarkerAlt;

    public ngOnInit(): void {
        this.initPickCarInformations();
    }

    private initPickCarInformations(): void {
        this.pickCarInformations = {
            type: this.type === 'pickup' ? 'Pickup' : 'DropOff',
            date: new Date(this.booking.booking.vehicleRental[this.type === 'pickup' ? 'begin' : 'end'].value),
            place: this.booking.getStation(this.type).name,
            address: this.booking.getStation(this.type).address.full,
        };


    }

}
